import React from 'react';
import { Line } from 'react-chartjs-2';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
}  from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);



export const sampleLineOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'Line Chart',
    },
  },
  elements: {
    point:{
        radius: 0,
    },
  },
};

const labels = ['-200', '-150','-100', '-50', 'Today'];

export const sampleLineData = {
  labels: labels,
  datasets: [
    {
      label: '2023',
      data: [6,5,4,3,2,6,8],
      fill: false,
      borderColor: 'rgba(255, 99, 132, 0.8)',
    },
    {
      label: '2024',
      data: [7,6,5,3,4,5,6],
      fill: false,
      borderColor: 'rgba(53, 162, 235, 0.8)',
    },
    {
      label: '2025 ',
      data: [10,12,3,4,5,1],
      fill: false,
      borderColor: 'rgba(53, 235, 162, 0.8)',
    },
    {
      label: '2026',
      data: [4,3,2,3,4,5],
      fill: false,
      borderColor: 'rgba(255, 220, 73, 0.8)',
    },
  ],
};

export const  LineChart = ({ chartData }, {chartOptions}) => {
  return (
    <div>
      <Line data={chartData} options={chartOptions} height="320px"/>
    </div>
  );
}
